module.exports = __webpack_public_path__ + "static/media/Assefaz.f5e0f265.png";